import { render, staticRenderFns } from "./LgFinderPageTipoGarantiaContrato.vue?vue&type=template&id=ced16456"
import script from "./LgFinderPageTipoGarantiaContrato.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoGarantiaContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports